export const getRelativeQuantity = (quantity, factor, mess = {}) => (
	quantity > factor ? 
		mess['RELATIVE_QUANTITY_MANY'] :
		(
			quantity > 0 && quantity <= factor ?
				mess['RELATIVE_QUANTITY_FEW'] :
				mess['RELATIVE_QUANTITY_NO']
		)
);